//      
                                                 

const immediate = {
  passive: false,
};
const delayed = {
  passive: true,
};

export default (options               ) =>
  options.shouldPublishImmediately ? immediate : delayed;



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-droppable-publisher/get-listener-options.js